import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	transition: opacity 0.3s ease;

	&.tab-enter {
		opacity: 0;
	}

	&.tab-enter-active,
	&.tab-enter-done,
	&.tab-exit {
		opacity: 1;
	}

	&.tab-exit-active {
		opacity: 0;
	}
`;

const StyledHeadContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	height: 80px;
	padding: 0 24px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledSearchInput = styled.input`
	width: 100%;
	background-color: transparent;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	text-align: center;
	color: #ffffff;
	transition: color 0.3s ease;
	outline: none;
	border: none;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
		user-select: none;
	}

	&:hover {
		&::placeholder {
			color: rgba(255, 255, 255, 0.5);
		}
	}
`;

const StyledSearchResultInfo = styled.div`
	display: flex;
	justify-content: space-between;
`;

const StyledSearchResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	height: 548px;
	overflow-y: scroll;
	padding: 27px 24px 30px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledSearchResultList = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

const StyledResetContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	opacity: 0.5;
	transition: opacity 0.3s ease;
	cursor: pointer;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
	}

	${TextLabel} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}

	&:hover {
		opacity: 1;
	}
`;

const StyledNotFoundContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 488px;

	${TextLabel} {
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledEmptyContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;

	${TextLabel} {
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export {
	StyledContainer,
	StyledHeadContainer,
	StyledSearchInput,
	StyledSearchResultInfo,
	StyledSearchResultList,
	StyledSearchResultContainer,
	StyledResetContainer,
	StyledNotFoundContainer,
	StyledEmptyContainer,
};
